import { getCurrentUser } from 'aws-amplify/auth';

/**
 * Generate a nonce for secure write operations
 * Format: timestamp.hash
 * The server will validate the age and hash
 */
export const generateNonce = async (): Promise<string> => {
  try {
    // Get current user
    const user = await getCurrentUser();
    
    // Create timestamp part
    const timestamp = Math.floor(Date.now() / 1000);
    
    // Create data to hash
    const dataToHash = `${timestamp}${user.userId}`;
    
    // Create hash using SubtleCrypto
    const encoder = new TextEncoder();
    const data = encoder.encode(dataToHash);
    const hashBuffer = await crypto.subtle.digest('SHA-256', data);
    
    // Convert hash to hex string
    const hashArray = Array.from(new Uint8Array(hashBuffer));
    const hashHex = hashArray.map(b => b.toString(16).padStart(2, '0')).join('');
    
    // Combine timestamp and hash
    return `${timestamp}.${hashHex}`;
  } catch (error) {
    console.error('Error generating nonce:', error);
    throw new Error('Failed to generate security token');
  }
};

/**
 * Verify if a nonce is still valid (not expired)
 */
export const isNonceValid = (nonce: string): boolean => {
  try {
    const [timestampStr] = nonce.split('.');
    const timestamp = parseInt(timestampStr, 10);
    const now = Math.floor(Date.now() / 1000);
    
    // Check if nonce is less than 1 hour old
    return (now - timestamp) < 3600;
  } catch {
    return false;
  }
};